{
  "WHATSAPP_TEMPLATES": {
    "MODAL": {
      "TITLE": "Whatsapp Skabeloner",
      "SUBTITLE": "Vælg den whatsapp skabelon, du vil sende",
      "TEMPLATE_SELECTED_SUBTITLE": "Configure template: {templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "Søg Skabeloner",
      "NO_TEMPLATES_FOUND": "Ingen skabeloner fundet for",
      "HEADER": "Header",
      "BODY": "Body",
      "FOOTER": "Footer",
      "BUTTONS": "Buttons",
      "CATEGORY": "Kategori",
      "MEDIA_CONTENT": "Media Content",
      "MEDIA_CONTENT_FALLBACK": "media content",
      "NO_TEMPLATES_AVAILABLE": "No WhatsApp templates available. Click refresh to sync templates from WhatsApp.",
      "REFRESH_BUTTON": "Refresh templates",
      "REFRESH_SUCCESS": "Templates refresh initiated. It may take a couple of minutes to update.",
      "REFRESH_ERROR": "Failed to refresh templates. Please try again.",
      "LABELS": {
        "LANGUAGE": "Sprog",
        "TEMPLATE_BODY": "Skabelon Krop",
        "CATEGORY": "Kategori"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "Variabler",
      "LANGUAGE": "Sprog",
      "CATEGORY": "Kategori",
      "VARIABLE_PLACEHOLDER": "Indtast {variable} værdi",
      "GO_BACK_LABEL": "Gå Tilbage",
      "SEND_MESSAGE_LABEL": "Send Besked",
      "FORM_ERROR_MESSAGE": "Udfyld venligst alle variabler før afsendelse",
      "MEDIA_HEADER_LABEL": "{type} Header",
      "OTP_CODE": "Enter 4-8 digit OTP",
      "EXPIRY_MINUTES": "Enter expiry minutes",
      "BUTTON_PARAMETERS": "Button Parameters",
      "BUTTON_LABEL": "Button {index}",
      "COUPON_CODE": "Enter coupon code (max 15 chars)",
      "MEDIA_URL_LABEL": "Enter {type} URL",
      "DOCUMENT_NAME_PLACEHOLDER": "Enter document filename (e.g., Invoice_2025.pdf)",
      "BUTTON_PARAMETER": "Enter button parameter"
    }
  }
}
